
































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// service methods
import validate from "@/directives/validate";
import { getSetting, setSetting } from "@/services/autoSettings/autoSettingsService";
import { getContracts } from "@/services/contracts/contractService";
import { getSolutions } from "@/services/solutions/solutionService";
// components
import vSelect from "vue-select";
import moment from "moment";
// types
import { Solution, SolutionTypeEnum } from "@/services/solutions/types";
import { TimeZone } from "@/services/timeZones/types";
import { boardValidators } from "@/components/solutions/validators";
import i18n from "@/i18n";
import { Contract, LicenceType, LicenceTypes, Licences } from "@/services/contracts/types";
import { TemplateTypeEnum } from "@/services/templates/types";
@Component({
    components: {
        vSelect
    },
    directives: {
        validate
    }
})
export default class SolutionSettings extends Vue {
    @Prop() collapseState!: boolean;
    @Prop() settings!: Solution;
    @Prop() timeZones!: any[];
    @Prop() templates!: any[];

    // local state
    localCollapseState = true;
    localSettings = {} as Solution;
    validators = boardValidators;
    solutionTypeEnum = SolutionTypeEnum;
    templateTypeEnum = TemplateTypeEnum;
    contracts = [] as Contract[];
    localContracts = [] as any[];
    licenceTypes = LicenceTypes;
    solutions = [] as Solution[];

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
        this.localSettings = this.settings;
    }

    async created() {
        this.contracts = await getContracts();
        this.solutions = await getSolutions();
        this.filterContractsByLinceceType();
        const browserLocation = Intl.DateTimeFormat().resolvedOptions().timeZone.split("/")[1];
        this.localSettings.timeZoneId = this.localSettings.timeZoneId || this.timeZones.find(x => x.displayName.includes(browserLocation)).id;
    }

    // Watchers
    @Watch("settings")
    onPropertyChanged() {
        this.localSettings = this.settings;
        this.filterContractsByLinceceType();
    }

    // computed
    get selectedTemplate() {
        return this.localSettings.templateId ? { name: this.localSettings.templateName, id: this.localSettings.templateId } : null as any;
    }

    set selectedTemplate(value: any) {
        this.localSettings.templateId = value ? value.id : "";
        this.localSettings.templateName = value ? value.name : "";
    }

    get selectedTimeZone() {
        return this.localSettings.timeZoneId ? { displayName: this.localSettings.timeZoneName, id: this.localSettings.timeZoneId } : null as any;
    }

    set selectedTimeZone(value: any) {
        this.localSettings.timeZoneId = value ? value.id : "";
        this.localSettings.timeZoneName = value ? value.displayName : "";
    }

    get solutionTypes() {
        return Object.keys(this.solutionTypeEnum).filter(x => !(parseInt(x) >= 0))
            .map(key => ({ name: i18n.t(`solution.${key}`), value: key }));
    }

    get selectedType() {
        return this.localSettings.type ? { name: i18n.t(`solution.${this.getKeyByValue(this.solutionTypeEnum, this.localSettings.type)}`), type: this.localSettings.type } : null as any;
    }

    set selectedType(value: any) {
        this.localSettings.type = value ? this.solutionTypeEnum[value] : null as any;
        this.filterContractsByLinceceType();
    }

    get templateSettings() {
        if (!this.localSettings.templateId) {
            return "#";
        }
        if (this.localSettings.templateType && this.localSettings.templateType === this.templateTypeEnum.sessions) {
            return {
                name: "updateSession",
                params: { sessionTemplateId: this.localSettings.templateId }
            };
        } else {
            return {
                name: "updatetemplate",
                params: { templateId: this.localSettings.templateId }
            };
        }
    }

    get contractSettings() {
        if (!this.localSettings.contractId) {
            return "#";
        }
        return {
            name: "selectedLicense",
            params: { contractId: this.localSettings.contractId }
        };
    }

    get playerSettings() {
        if (!this.localSettings.playerId) {
            return "#";
        }
        return {
            name: "updatePlayer",
            params: { playerId: this.localSettings.playerId }
        };
    }

    // methods
    updateTimeZoneState(timeZone: TimeZone) {
        if (timeZone) {
            this.validators.timeZone.state = null;
            this.validators.timeZone.message = "";
            this.validators.timeZone.value = timeZone;
        } else {
            this.localSettings.timeZoneId = "";
            this.validators.timeZone.state = false;
        }
    }

    updateTemplateState(template: any) {
        if (!template) {
            this.localSettings.templateId = "";
            this.localSettings.width = 0;
            this.localSettings.height = 0;
        } else {
            const currentTemplate = this.templates.filter(x => x.id === template)[0];
            this.localSettings.width = currentTemplate.width;
            this.localSettings.height = currentTemplate.height;
        }
    }

    updateTypeState(type: any) {
        if (type) {
            this.validators.type.state = null;
            this.validators.type.message = "";
            this.validators.type.value = type;
        } else {
            this.validators.type.state = false;
        }
    }

    onContractChange(contract: Contract) {
        if (!contract) {
            const solution = this.solutions.find(x => x.id === this.localSettings.id);
            if (solution) solution.contractId = null;
        }
    }

    emitData() {
        this.$emit("settingsUpdated", JSON.stringify(this.localSettings));
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "SolutionSettings.vue", state: state });
    }

    getKeyByValue(object: any, value: any) {
        return Object.keys(object).find(key => object[key] === value);
    }

    filterContractsByLinceceType() {
        if (!this.localSettings.type) return;
        const licence = Object.entries(this.licenceTypes)
            .filter(([key, value]) => Object.entries(value)
                .find(([k, v]) => k === this.getKeyByValue(this.solutionTypeEnum, this.localSettings.type)))[0][0];
        this.localContracts = this.contracts.filter(x => Object.entries(x.licences).find(([key, value]) => key === licence && (value as number) > 0))
            .map(x => {
                const total = x.licences[licence as keyof Licences] as number;
                const used = this.solutions.filter(s => s.contractId === x.id && Object.values(this.licenceTypes[licence as keyof LicenceType]).includes(s.type)).length;
                const available = total - used;
                const number = x.number !== null ? x.number : "N/A";
                return {
                    name: `${x.name} (${number}) (${available} ${i18n.t("contract.available")})`,
                    id: x.id,
                    selectable: available > 0
                };
            });
    }
}
